import { C as Z, a as tt, b as et, d as ot, c as st, D as at } from "../../chunks/Carousel.BZ3e8yYk.js";
import { j as u } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { createContext as $, useContext as A, forwardRef as p, useRef as D, useMemo as N, useLayoutEffect as T, useEffect as I, Children as P, isValidElement as L, useState as v, useCallback as y } from "react";
import { c as f } from "../../chunks/index.CxSWpsOB.js";
import { A as E } from "../../chunks/ArrowButton.C_hYcEFL.js";
const M = 0.8, _ = 160, k = "transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease", z = $(null), g = () => {
  const t = A(z);
  if (!t)
    throw new Error("useRotationalCarousel must be used within a <RotationalCarousel />");
  return t;
}, F = (t, e) => (t % e + e) % e, O = (t, e, o) => {
  if (o === 0) return t - e;
  const s = t - e, a = Math.floor(o / 2);
  return F(s + a, o) - a;
}, X = (t, e, o, s) => t === 0 ? {
  transform: `translateX(${-e}px) scale(1)`,
  zIndex: 10,
  opacity: 1
} : t === -1 ? {
  transform: `translateX(${-s - e}px) scale(${o})`,
  zIndex: 5,
  opacity: 0.7
} : t === 1 ? {
  transform: `translateX(${s - e}px) scale(${o})`,
  zIndex: 5,
  opacity: 0.7
} : {
  transform: `translateX(${(t < 0 ? -1 : 1) * s * 2.8 - e}px) scale(${o * 0.75})`,
  zIndex: 1,
  opacity: 0,
  pointerEvents: "none"
}, B = (...t) => (e) => t.forEach((o) => {
  o && (typeof o == "function" ? o(e) : o.current = e);
}), S = p(({
  index: t,
  children: e,
  className: o
}, s) => {
  const {
    activeIndex: a,
    totalItems: n,
    halfWidth: i,
    sideScale: R,
    sideOffset: w,
    setCardDimensions: m
  } = g(), r = O(t, a, n), l = D(null), x = N(() => B(s, l), [s]);
  return T(() => {
    if (r !== 0 || !l.current) return;
    const {
      width: d,
      height: C
    } = l.current.getBoundingClientRect();
    m(d, C);
  }, [r, m]), I(() => {
    if (r !== 0 || !l.current) return;
    const d = l.current, C = new ResizeObserver(([b]) => {
      const {
        inlineSize: h,
        blockSize: c
      } = b.borderBoxSize[0];
      m(h, c);
    });
    return C.observe(d), () => C.disconnect();
  }, [r, m]), i === 0 ? r !== 0 ? null : /* @__PURE__ */ u.jsx("div", { ref: x, className: f("tw-absolute tw-top-0 tw-left-1/2 tw-invisible", o), children: e }) : Math.abs(r) > 2 ? null : /* @__PURE__ */ u.jsx("div", { ref: x, role: "group", "aria-roledescription": "slide", "aria-label": `Slide ${t + 1} of ${n}`, "aria-hidden": Math.abs(r) > 1, className: f("tw-absolute tw-top-0 tw-left-1/2", o), style: {
    ...X(r, i, R, w),
    transition: k
  }, children: e });
});
S.displayName = "RotationalCarouselItem";
const H = p(({
  children: t,
  className: e
}, o) => {
  const {
    cardHeight: s,
    setTotalItems: a
  } = g(), n = N(() => P.toArray(t).filter((i) => L(i) && i.type === S).length, [t]);
  return I(() => {
    a(n);
  }, [n, a]), // height is driven by cardHeight from context (measured by the center item).
  // Without an explicit height the container would be 0px tall because all
  // children are absolutely positioned.
  /* @__PURE__ */ u.jsx("div", { ref: o, className: f("tw-relative tw-w-full", e), style: {
    height: s
  }, children: t });
});
H.displayName = "RotationalCarouselContent";
const U = p(({
  className: t
}, e) => {
  const {
    goPrev: o
  } = g();
  return /* @__PURE__ */ u.jsx(E, { ref: e, "aria-label": "Previous slide", className: f(
    // Centered vertically over the content area; left-side offset matches
    // the right-side offset on RotationalCarouselNext for visual symmetry.
    "tw-absolute tw-left-[5%] tw-top-1/2 tw--translate-y-1/2 tw-z-20",
    t
  ), onClick: o });
});
U.displayName = "RotationalCarouselPrevious";
const V = p(({
  className: t
}, e) => {
  const {
    goNext: o
  } = g();
  return /* @__PURE__ */ u.jsx(E, { ref: e, right: !0, "aria-label": "Next slide", className: f(
    // Centered vertically over the content area; right-side offset mirrors
    // the left-side offset on RotationalCarouselPrevious for visual symmetry.
    "tw-absolute tw-right-[5%] tw-top-1/2 tw--translate-y-1/2 tw-z-20",
    t
  ), onClick: o });
});
V.displayName = "RotationalCarouselNext";
const W = p(({
  children: t,
  className: e,
  sideScale: o = M,
  sideOffset: s = _
}, a) => {
  const [n, i] = v(0), [R, w] = v(0), [m, r] = v(0), [l, x] = v(0), d = m / 2, C = y((c, j) => {
    r(c), x(j);
  }, []), b = y(() => w((c) => c - 1), []), h = y(() => w((c) => c + 1), []);
  return /* @__PURE__ */ u.jsx(z.Provider, { value: {
    activeIndex: R,
    totalItems: n,
    halfWidth: d,
    cardHeight: l,
    sideScale: o,
    sideOffset: s,
    setCardDimensions: C,
    setTotalItems: i,
    goPrev: b,
    goNext: h
  }, children: /* @__PURE__ */ u.jsx("div", { ref: a, role: "region", "aria-roledescription": "carousel", className: f("tw-w-full", e), children: t }) });
});
W.displayName = "RotationalCarousel";
export {
  Z as Carousel,
  tt as CarouselContent,
  et as CarouselItem,
  ot as CarouselNext,
  st as CarouselPrevious,
  at as DotNavigation,
  W as RotationalCarousel,
  H as RotationalCarouselContent,
  S as RotationalCarouselItem,
  V as RotationalCarouselNext,
  U as RotationalCarouselPrevious
};
//# sourceMappingURL=index.js.map
